"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnv = exports.EnvProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const EnvContext = (0, react_1.createContext)({});
/**
 * Provides the environment to the children component.
 * To make this work, pass STAGE variable in your app container
 * Example: https://github.sc-corp.net/Snapchat/web/pull/3831/files
 */
function EnvProvider({ children, env }) {
    const envRef = (0, react_1.useRef)(env);
    return (0, jsx_runtime_1.jsx)(EnvContext.Provider, { value: envRef.current, children: children });
}
exports.EnvProvider = EnvProvider;
const useEnv = () => {
    const env = (0, react_1.useContext)(EnvContext);
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!env) {
        throw new Error("useEnv must be used within an EnvProvider");
    }
    return env;
};
exports.useEnv = useEnv;
//# sourceMappingURL=provider.js.map